import React from 'react';

function ResponsePage() {
    return (
        <div className="form-container response-page">
            <div className="check-img">
                <img src="/Images/check.png" alt=""/>
            </div>
            <div className="res-title">Application successfully sent</div>
            <div className="description">Once the information is confirmed, you will receive an email to start adding your branches.</div>

            <div className="btn-container">
                <button className="continue-btn" onClick={()=>{
                    window.location.href = "/merchantinformation"
                }}>Done</button>
            </div>
        </div>
    );
}

export default ResponsePage;